<template>
  <v-container
    fluid
    pa-0
  >
    <v-row no-gutters>
      <v-col cols="12">
        <v-container
          class="brand-beige-dark"
          fluid
          style="min-height: calc(100vh - 55px);"
        >
          <v-row>
            <v-col
              cols="12"
              lg="10"
              offset-lg="1"
            >
              <div class="text-center">
                <div
                  class="notched-corner fill-height"
                  style="height: calc(100vh - 215px)"
                >
                  <v-img
                    :alt="$t('Common.App.Title')"
                    :contain="false"
                    :src="HomeStoa"
                    height="100%"
                  />
                </div>

                <div class="brand-text-small-title my-8">
                  {{ $t('Home.OneOrderOnePayment.Body') }}
                </div>

                <div class="down-arrow" />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        lg="10"
        offset-lg="1"
      >
        <v-container fluid>
          <v-row
            v-if="AppConfig.Marketplace.TagsEnabled && !!AppTags.length"
            :dense="$vuetify.breakpoint.xsOnly"
            class="mt-md-10"
          >
            <v-col cols="12">
              <h2 class="brand-text-heading brand-green-dark--text">
                {{ $tc('Tag.Title', 0).toLocaleUpperCase($i18n.locale) }}
              </h2>

              <v-divider
                class="mt-3"
                style="border-color: var(--v-brand-green-dark-base)"
              />
            </v-col>

            <v-col
              v-if="!!AppTags.length"
              cols="12"
            >
              <template v-for="(tag, idx) in AppTags">
                <v-chip
                  v-if="tag.Visible"
                  :key="`tag-${idx}`"
                  :color="tag.Color"
                  :dark="getContrastColor(tag.Color,168) === 'white'"
                  :to="{name: 'Tag', params: {slug: getTranslatedField(tag, 'Slug'), id: tag.Id}}"
                  class="px-6 mr-2 mb-2"
                  label
                  large
                >
                  <v-icon
                    v-if="tag.Icon && !tag.LabelOnly"
                    left
                  >
                    {{ tag.Icon }}
                  </v-icon>

                  <span class="mt-1 brand-text-title">{{ getTranslatedField(tag, 'Label').toLocaleUpperCase($i18n.locale) }}</span>
                </v-chip>
              </template>
            </v-col>
          </v-row>

          <v-row
            v-if="!!AppStores.length"
            :dense="$vuetify.breakpoint.xsOnly"
            class="mt-8 mt-md-16"
          >
            <v-col cols="12">
              <h2 class="brand-text-heading brand-green-dark--text">
                {{ $tc('Store.List.Title', 0).toLocaleUpperCase($i18n.locale) }}
              </h2>

              <v-divider
                class="mt-3"
                style="border-color: var(--v-brand-green-dark-base)"
              />
            </v-col>

            <template v-for="(store, idx) in AppStores">
              <v-col
                v-if="!storeIsHidden(store)"
                :key="`store-${idx}`"
                cols="6"
                lg="4"
                sm="6"
              >
                <store-card
                  :dense="$vuetify.breakpoint.xsOnly"
                  :item="store"
                  :to="{name: 'Store', params: {slug: store.Slug, id: store.Id}}"
                  hover
                  hover-img-swap
                  hover-zoom
                />
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeMixin from '@/theme/default/views/home/Home.js'
//import HomeStoa from '@/app-theme/assets/img/home/home-stoa.webp'
import HomeStoa from '@/app-theme/assets/img/home/home.webp'

export default {
  name    : 'Home',
  mixins  : [HomeMixin],
  computed: {
    HomeStoa() {
      return HomeStoa
    }
  }
}
</script>

<style scoped src="@/theme/default/views/home/Home.css"></style>
<style scoped>
.notched-corner {
  width: 100%;
  height: 100%;
  padding: 1px;
  overflow: hidden;
  clip-path: polygon(
      0 14px,
      14px 0,
      calc(100% - 14px) 0,
      100% 14px, 100% calc(100% - 14px),
      calc(100% - 14px) 100%,
      14px 100%,
      0% calc(100% - 14px)
  )
}

.center-vertical-horizontal {
  position: relative;
}

@media (min-width: 600px) {
  .notched-corner {
    clip-path: polygon(
        0 20px,
        20px 0,
        calc(100% - 20px) 0,
        100% 20px, 100% calc(100% - 20px),
        calc(100% - 20px) 100%,
        20px 100%,
        0% calc(100% - 20px)
    )
  }
}

@media (min-width: 960px) {
  .notched-corner {
    clip-path: polygon(
        0 25px,
        25px 0,
        calc(100% - 25px) 0,
        100% 25px, 100% calc(100% - 25px),
        calc(100% - 25px) 100%,
        25px 100%,
        0% calc(100% - 25px)
    )
  }
}

@media (min-width: 1264px) {
  .notched-corner {
    clip-path: polygon(
        0 45px,
        45px 0,
        calc(100% - 45px) 0,
        100% 45px, 100% calc(100% - 45px),
        calc(100% - 45px) 100%,
        45px 100%,
        0% calc(100% - 45px)
    )
  }
}

@media (min-width: 1904px) {
  .notched-corner {
    clip-path: polygon(
        0 55px,
        55px 0,
        calc(100% - 55px) 0,
        100% 55px, 100% calc(100% - 55px),
        calc(100% - 55px) 100%,
        55px 100%,
        0% calc(100% - 55px)
    )
  }
}


@media (max-height: 599px) or (min-width: 800px) {
  .center-vertical-horizontal {
    position: initial;
    top: initial;
    left: initial;
    transform: initial;
  }
}

.down-arrow {
  position: absolute;
  top: calc(100vh - 110px);
  left: calc(50% - 8px);
  width: 0;
  height: 18px;
  border: 1px solid;
  border-radius: 2px;
  animation: jumpInfinite 1.5s infinite;
}

.down-arrow:after {
  content: " ";
  position: absolute;
  top: 10px;
  left: -4px;
  width: 8px;
  height: 8px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  border-radius: 2px;
  transform: rotateZ(45deg);
}

@keyframes jumpInfinite {
  0% {
    margin-top: 0;
  }
  50% {
    margin-top: 12px;
  }
  100% {
    margin-top: 0;
  }
}
</style>
